"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CEKHeap = void 0;
var CEKValue_1 = require("../CEKValue/CEKValue.js");
var CEKHeap = /** @class */ (function () {
    function CEKHeap(init) {
        if (init === void 0) { init = []; }
        this._heap = init;
    }
    CEKHeap.prototype.clone = function () {
        return new CEKHeap(this._heap.map(function (uplc) { return uplc.clone(); }));
    };
    CEKHeap.prototype.add = function (varValue) {
        var alreadyPresent = this._heap.findIndex(function (heapValue) { return (0, CEKValue_1.eqCEKValue)(heapValue, varValue); });
        if (alreadyPresent < 0) {
            this._heap.push(Object.freeze(varValue));
            return this._heap.length - 1;
        }
        return alreadyPresent;
    };
    CEKHeap.prototype.get = function (idx) {
        if (idx < 0 || idx >= this._heap.length || idx !== Math.round(idx))
            return undefined;
        return this._heap[idx].clone();
    };
    CEKHeap.prototype._unsafe_clear = function () {
        this._heap.length = 0;
    };
    return CEKHeap;
}());
exports.CEKHeap = CEKHeap;
